import { apiRequest } from './client';

export const login = (email, password) => apiRequest('/api/v1/auth/login', {
  method: 'POST',
  mode: 'cors',
  body: {
    email,
    password
  }
});

export const register = ({ email, first_name, last_name, password, terms_version }) => {
  const body = {
    email,
    password
  };

  if (first_name) {
    body.first_name = first_name;
  }

  if (last_name) {
    body.last_name = last_name;
  }

  if (terms_version) {
    // Pass the accepted Terms version through to the API so it can be persisted as user meta.
    body.terms_version = terms_version;
  }

  return apiRequest('/api/v1/auth/register', {
    method: 'POST',
    mode: 'cors',
    body
  });
};

export const sendPasswordReset = (email) => apiRequest('/api/v1/send_password_reset', {
  method: 'POST',
  mode: 'cors',
  body: {
    email
  }
});

export const validateResetToken = (token) => apiRequest('/api/v1/validate_reset_token', {
  method: 'POST',
  mode: 'cors',
  body: {
    token
  }
});

export const resetPassword = ({ token, new_password, confirm_password }) => apiRequest('/api/v1/reset_password', {
  method: 'POST',
  mode: 'cors',
  body: {
    token,
    new_password,
    confirm_password
  }
});
